import SupportPanel from '@/components/support/SupportPanel'
import { useAuth } from '@/lib/auth-context'

export default function TeacherSupport() {
  const { profile } = useAuth()
  const teacherId = profile?.id

  return (
    <div className="space-y-6">
      <header className="space-y-1">
        <h1 className="text-2xl font-semibold text-cocoa">Support Tickets</h1>
        <p className="text-sm text-cocoa/70">
          Reach the Tower team for ordering help, classroom setup, or student support.
        </p>
      </header>
      <SupportPanel
        roleLabel="Teacher"
        defaultCategory="teacher_support"
        contextMeta={{ surface: 'teacher_portal', teacher_id: teacherId ? String(teacherId) : undefined }}
      />
    </div>
  )
}
